import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function makeSlideInTranslation(translationType, fromValue) {
  return {
    from: _defineProperty({}, translationType, fromValue),
    to: _defineProperty({}, translationType, 0)
  };
}

export var slideInDown = makeSlideInTranslation('translateY', -100);

if (typeof slideInDown !== 'undefined' && slideInDown && slideInDown === Object(slideInDown) && Object.isExtensible(slideInDown) && !slideInDown.hasOwnProperty('__filemeta')) {
  Object.defineProperty(slideInDown, '__filemeta', {
    configurable: true,
    value: {
      name: "slideInDown",
      filename: "node_modules/react-native-animatable/definitions/sliding-entrances.js"
    }
  });
}

export var slideInUp = makeSlideInTranslation('translateY', 100);

if (typeof slideInUp !== 'undefined' && slideInUp && slideInUp === Object(slideInUp) && Object.isExtensible(slideInUp) && !slideInUp.hasOwnProperty('__filemeta')) {
  Object.defineProperty(slideInUp, '__filemeta', {
    configurable: true,
    value: {
      name: "slideInUp",
      filename: "node_modules/react-native-animatable/definitions/sliding-entrances.js"
    }
  });
}

export var slideInLeft = makeSlideInTranslation('translateX', -100);

if (typeof slideInLeft !== 'undefined' && slideInLeft && slideInLeft === Object(slideInLeft) && Object.isExtensible(slideInLeft) && !slideInLeft.hasOwnProperty('__filemeta')) {
  Object.defineProperty(slideInLeft, '__filemeta', {
    configurable: true,
    value: {
      name: "slideInLeft",
      filename: "node_modules/react-native-animatable/definitions/sliding-entrances.js"
    }
  });
}

export var slideInRight = makeSlideInTranslation('translateX', 100);

if (typeof slideInRight !== 'undefined' && slideInRight && slideInRight === Object(slideInRight) && Object.isExtensible(slideInRight) && !slideInRight.hasOwnProperty('__filemeta')) {
  Object.defineProperty(slideInRight, '__filemeta', {
    configurable: true,
    value: {
      name: "slideInRight",
      filename: "node_modules/react-native-animatable/definitions/sliding-entrances.js"
    }
  });
}